import { Checkbox } from "@mantine/core";
import CheckboxSurvey from "../../../components/form/Checkbox";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const { t } = useTranslation();
  return (
    <CheckboxSurvey
      label={t("harassingGender.label")}
      {...form.getInputProps("PAD_001_002AS")}
    >
      <Checkbox label={`${t("gender.man")}.`} value="PAD_001AS" />
      <Checkbox label={`${t("gender.woman")}.`} value="PAD_002AS" />
    </CheckboxSurvey>
  );
};

export default Component;
